export default __webpack_public_path__ + "static/media/apollo-interface.5f6940f3.md";